import { useState } from 'react';

interface Option {
  initialValue?: boolean;
}

export function useCollapse(options?: Option) {
  const [isOpen, setIsOpen] = useState(options?.initialValue ?? false);

  return {
    toggle: () => setIsOpen(p => !p),
    setIsOpen,
    isOpen,
  };
}
